import { config } from '#app/config'
import imgAPI from '#app/lib/api/img'
import { isRelativeUrl, isUrl } from '#app/lib/boolean_tests'
import { capitalize, dropLeadingSlash } from '#app/lib/utils'
import type { AbsoluteUrl, RelativeUrl, Url } from '#server/types/common'
import type { EntityUri } from '#server/types/entity'
import type { ImagePath } from '#server/types/image'
import { getCurrentLang } from '#user/lib/i18n'
import { getQuerystringParameter } from '../querystring_helpers'

const { instanceName } = config
const { origin } = location

const capitalizedInstanceName = capitalize(instanceName)

function absolutePath (url: Url) {
  if (url?.[0] === '/') {
    return origin + url
  } else {
    return url
  }
}

export function applyTransformers (key: string, value: unknown) {
  if (transformers[key] != null) {
    return transformers[key](value)
  } else {
    return value
  }
}

export const transformers = {
  title: (value: string) => {
    return value.toLowerCase().endsWith(instanceName.toLowerCase()) ? value : `${value} - ${capitalizedInstanceName}`.replaceAll(/\s*-\s*-\s*/g, ' - ')
  },
  url: (canonicalPath: string) => {
    canonicalPath = dropLeadingSlash(canonicalPath)
    let url = `${window.location.origin}/${canonicalPath}`

    // Preserve parameters that make a resource different enough,
    // that the prerendered version returned should be different
    const lang = getQuerystringParameter('lang') || getCurrentLang() || 'en'
    url += `?lang=${lang}`

    return url as AbsoluteUrl
  },
  image: (url: ImagePath | Url | EntityUri) => {
    if (url.startsWith('/public/images')) {
      return absolutePath(url as RelativeUrl)
    } else if (url.match(/\d+x\d+/)) {
      return absolutePath(url as Url)
    } else if (isUrl(url) || isRelativeUrl(url)) {
      return absolutePath(imgAPI(url) as Url)
    } else {
      return imgAPI(url)
    }
  },
}
